/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RefNumberInput/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function RefNumberInput({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsPostPayment/Content/Content/Content/RefNumberInput",
  onChange,
  isSubmitting
  
}) {
let paymentsPostPaymentReferenceNumberValueData = fromData.useDataValue({ viewPath,
context: 'payments_post_payment',
path: 'reference_number',
})
let paymentsPostPaymentReferenceNumberChangeData = fromData.useDataChange({ viewPath,
context: 'payments_post_payment',
path: 'reference_number',
})
let paymentsPostPaymentIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'payments_post_payment',
})
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 required={false}
 data="payments_post_payment.reference_number"
 value={paymentsPostPaymentReferenceNumberValueData}
 onChange={paymentsPostPaymentReferenceNumberChangeData}
 data="payments_post_payment"
 disabled={paymentsPostPaymentIsSubmittingData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Ref number"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
 backgroundColor="white"
 borderColor={dtColorsNeutral300}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}